import { customerApi } from './api';

export const tutorSearchService = {
  searchTutors: async (filters = {}) => {
    const params = new URLSearchParams();
    
    if (filters.class) params.append('class', filters.class);
    if (filters.classes && filters.classes.length > 0) {
      filters.classes.forEach(c => params.append('classes[]', c));
    }
    if (filters.subject) params.append('subject', filters.subject);
    if (filters.tutor_type) params.append('tutor_type', filters.tutor_type);
    if (filters.gender) params.append('gender', filters.gender);
    if (filters.experience_min) params.append('experience_min', filters.experience_min);
    if (filters.experience_max) params.append('experience_max', filters.experience_max);
    if (filters.hourly_rate_min) params.append('hourly_rate_min', filters.hourly_rate_min);
    if (filters.hourly_rate_max) params.append('hourly_rate_max', filters.hourly_rate_max);
    if (filters.latitude) params.append('latitude', filters.latitude);
    if (filters.longitude) params.append('longitude', filters.longitude);
    if (filters.radius_km) params.append('radius_km', filters.radius_km);
    if (filters.page) params.append('page', filters.page);
    if (filters.per_page) params.append('per_page', filters.per_page);
    
    const response = await customerApi.get(`/tutors?${params.toString()}`);
    const data = response.data?.data || {};
    return {
      tutors: data.tutors || [],
      pagination: data.pagination || {}
    };
  },

  getTutor: async (id) => {
    const response = await customerApi.get(`/tutors/${id}`);
    return response.data?.data || response.data;
  },
};
